var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAngry1(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "angry",
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_9997",
    "data-name": "Path 9997",
    d: "M25,8A25,25,0,1,0,50,33,25,25,0,0,0,25,8ZM13.71,31.387a3.213,3.213,0,0,1,1.03-2.362l-3.107-.931A1.613,1.613,0,1,1,12.56,25l8.065,2.419a1.613,1.613,0,0,1-.464,3.158h-.1a3.226,3.226,0,1,1-6.351.806ZM30.677,46.916a7.664,7.664,0,0,0-11.353,0,1.616,1.616,0,0,1-2.492-2.057,10.678,10.678,0,0,1,16.331,0A1.613,1.613,0,0,1,30.677,46.916Zm7.79-18.823-3.185.955a3.226,3.226,0,1,1-5.343,1.532,1.613,1.613,0,0,1-.465-3.157L37.539,25a1.613,1.613,0,1,1,.927,3.09h0Z",
    transform: "translate(0 -8)",
    fill: "#ff5962",
    opacity: 0.4
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9998",
    "data-name": "Path 9998",
    d: "M114.133,178.478l-8.065-2.419a1.613,1.613,0,0,0-.927,3.091h0l3.107.931a3.226,3.226,0,1,0,5.321,1.555h.1a1.613,1.613,0,0,0,.463-3.158Zm18.924-1.338a1.613,1.613,0,0,0-2.009-1.081h0l-8.065,2.419a1.613,1.613,0,0,0,.464,3.157,3.226,3.226,0,1,0,5.343-1.532l3.183-.955a1.613,1.613,0,0,0,1.085-2.006h0Z",
    transform: "translate(-93.508 -159.056)",
    fill: "#ff5962"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngry1);
export default __webpack_public_path__ + "static/media/angry-1.b8ea020fd47da4e1a48d6fdb03a18b7c.svg";
export { ForwardRef as ReactComponent };